module.exports = __webpack_public_path__ + "static/img/ktcu-cs-competition-proposal.4b16cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ktcu-cs-competition-proposal.jpg
// module id = KBOc
// module chunks = 0